import { apps } from './apps';

export const environment = {
  environment: 'production',
  production: true,
  appDomain: 'umami-view.app',
  appUrl: 'https://umami-view.app',
  apiUrl: 'https://isa-api.umami-view.app',
  integrationsApiUrl: 'https://integrations-api.umami-view.app',
  workSchedulerApi: 'https://work-scheduler-api.umami-view.app',
  spaceUrl: 'https://isaprod.blob.core.windows.net',
  msAutosaveDebounceTime: 2000,
  googleMapsKey: 'AIzaSyD_0ZSVH1L0Dn80itPWkk-JLBW5he81auY',
  defaultTheme: 'light-blue',
  googleTagManagerKey: 'GTM-TKK928M',
  userBackKey: '29834|43651|WOjV9G1GukoQVl70cgggNrVhN',
  userBackPortalUrl: 'https://umamiview.ideas.userback.io/p/mvoKD3fU0d',
  intercomAppId: 'ruqr1mvm',
  supportPhoneNumber: '+49 9904 9689489',
  notificationsCenterUri: 'https://notifications-api.umami-view.app',
  keycloak: {
    url: 'https://umami-view.app/auth',
    realm: 'isa',
    clientId: 'isa',
    enableLogging: false,
  },
  agGridKey:
    'Using_this_{AG_Grid}_Enterprise_key_{AG-096583}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Umami_Ware_GmbH}_is_granted_a_{Multiple_Applications}_Developer_License_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{2_March_2027}____[v3]_[01]_MTgwMzk0NTYwMDAwMA==9883911bf1a42c86de4a4ad6f1ea112f',
  apps: {
    isa: {
      ...apps.isa,
      host: 'https://umami-view.app',
    },
    glasses: {
      ...apps.glasses,
      host: 'https://glasses-1.umami-view.app',
    },
    glassesV2: {
      ...apps.glassesV2,
      host: 'https://glasses-v2-1.umami-view.app',
      apiUrl: 'https://glasses-v2-api.umami-view.app',
    },
    visionProfile: {
      ...apps.visionProfile,
      host: 'https://vision-profile-1.umami-view.app',
    },
    caseHistory: {
      ...apps.caseHistory,
      host: 'https://case-history-1.umami-view.app',
    },
    measures: {
      ...apps.measures,
      actionButtonComponent: 'CreateActionButtonComponent',
      embeddedActionIcon: undefined,
      embeddedActionParam: undefined,
      host: 'https://measures-1.umami-view.app',
    },
    integrations: {
      ...apps.integrations,
      host: 'https://integrations-1.umami-view.app',
    },
    calendar: {
      ...apps.calendar,
      host: 'https://calendar-1.umami-view.app',
    },
    workspace: {
      ...apps.workspace,
      host: 'https://workspace-1.umami-view.app',
    },
    times: {
      ...apps.times,
      host: 'https://times-1.umami-view.app',
    },
    messages: {
      ...apps.messages,
      host: 'https://messages-1.umami-view.app',
    },
    marketing: {
      ...apps.marketing,
      host: 'https://marketing-1.umami-view.app',
    },
    payments: {
      ...apps.payments,
      host: 'https://payments-1.umami-view.app',
    },
    analytics: {
      ...apps.analytics,
      host: 'https://analytics-1.umami-view.app',
    },
    products: {
      ...apps.products,
      actionButtonComponent: 'CreateActionButtonComponent',
      host: 'https://products-1.umami-view.app',
    },
    migrate: {
      ...apps.migrate,
      host: 'https://migrate-1.umami-view.app',
    },
    catalogs: {
      ...apps.catalogs,
      host: 'https://catalogs-1.umami-view.app',
    },
    businessActivity: {
      ...apps.businessActivity,
      host: 'https://business-activity-1.umami-view.app',
    },
  },
};
